<template>
  <!--begin::Footer-->
  <div
    class="app-sidebar-footer flex-column-auto pt-3 mb-5"
    id="kt_app_sidebar_footer"
  >
    <div
      class="menu menu-column menu-rounded menu-sub-indention px-3"
      data-kt-menu="true"
    >
      <section class="mb-5">
        <div class="menu-content">
          <span class="menu-heading fw-bold text-uppercase fs-7">
            Support for investing in Africa
          </span>
        </div>
        <div class="menu-item">
          <router-link
            class="menu-link"
            exact-active-class="active"
            to="/landing/africa-booklet"
          >
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/icons/menu/booklet.svg"
                />
              </span>
            </span>
            <span class="menu-title">Opportunity booklet</span>
            <span class="menu-arrow"></span>
          </router-link>
        </div>
        <div class="menu-item">
          <a
            class="menu-link"
            href="https://www.prosperafrica.gov/services/invest-in-africa/"
            target="_blank"
          >
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/icons/menu/using.svg"
                />
              </span>
            </span>
            <span class="menu-title">Using this dealroom</span>
            <span class="svg-icon">
              <inline-svg src="media/icons/menu/open-in-new.svg" />
            </span>
          </a>
        </div>
        <div class="menu-item">
          <router-link
            class="menu-link"
            exact-active-class="active"
            to="/sectors"
          >
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/icons/menu/investing.svg"
                />
              </span>
            </span>
            <span class="menu-title">Investing by sector</span>
            <span class="menu-arrow"></span>
          </router-link>
        </div>
        <div class="menu-item">
          <a
            class="menu-link"
            href="https://www.prosperafrica.gov/toolkit/"
            target="_blank"
          >
            <span class="menu-icon">
              <span class="svg-icon">
                <inline-svg
                  class="inline-svg"
                  src="media/icons/menu/toolkit.svg"
                />
              </span>
            </span>
            <span class="menu-title">Prosper Africa Toolkit</span>
            <span class="svg-icon">
              <inline-svg src="media/icons/menu/open-in-new.svg" />
            </span>
          </a>
        </div>
      </section>
    </div>
  </div>
  <!--end::Footer-->
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "sidebar-footer",
});
</script>

<style scoped>
.app-sidebar-footer {
  background: #f9fafb;
}

.menu-title {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 12px;
}
.inline-svg {
  width: 20px;
}
.menu-heading {
  color: #0e3167;
  padding: 0px 14px;
}
.menu-item.active {
  transition: color 0.2s ease;
  background-color: var(--kt-app-sidebar-light-menu-link-bg-color-active);
  color: var(--kt-primary);
}
</style>
